'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import AuthShell from '@/components/AuthShell'
import { login } from '@/lib/auth/cognito'

export default function LoginPage() {
  const router = useRouter()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const forwardedEmail = params.get('email')
    if (forwardedEmail) {
      setEmail(forwardedEmail)
    }
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    try {
      setIsSubmitting(true)
      await login({ email, password })
      router.push('/en/portal')
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Login failed.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AuthShell
      title="Student Login"
      subtitle="Sign in to continue to your student portal."
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-brand-charcoal mb-1">
            Email
          </label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-brand-cool-gray rounded-lg focus:ring-2 focus:ring-brand-green outline-none"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-semibold text-brand-charcoal mb-1">
            Password
          </label>
          <input
            id="password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border border-brand-cool-gray rounded-lg focus:ring-2 focus:ring-brand-green outline-none"
          />
        </div>

        {error ? <p className="text-sm text-brand-red">{error}</p> : null}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 rounded-lg font-semibold text-white bg-brand-green hover:bg-brand-green-deep disabled:bg-brand-muted"
        >
          {isSubmitting ? 'Logging in...' : 'Log in'}
        </button>

        <Link href="/en/reset-password" className="inline-block text-sm font-semibold text-brand-green hover:text-brand-green">
          Forgot password?
        </Link>
      </form>
    </AuthShell>
  )
}
